import { AnimatePresence } from 'framer-motion'

import { useManagementSearchUnitPlans } from '@apps-common/apis/management/unit-plan'
import { UnitPlanCardSkeleton, UnitPlanListCard } from '@apps-common/apps/portal/pages/management/components/unit-plan'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const UnitPlanInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementSearchUnitPlans({
    search: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(20).keys()).map((n, i) => <UnitPlanCardSkeleton key={`unit-plan-card-skeleton-${i}`} />)}
            {!loading && data?.map((p) => <UnitPlanListCard key={`unit-plan-list-${p.unitPlanId}`} plan={p} onChangeCallback={refetch} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No plan results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
